import React from "react";
import { Materials } from "./Materials";
import { Parametters } from "./Parametters";
import { BoardManager } from "../../functions/BoardManager";

export const BoardStyles = ({
  boardMaterials,
  boardParametters,
  activeStep,
  handleNextStep,
  basePrice,
  setOverrideStep,
  activeProduct,
  setActiveProduct,
  setPrice,
  dims,
  state,
  setState,
  resetLegs = {},
}) => {
  const manager = new BoardManager(
    activeProduct,
    setActiveProduct,
    basePrice,
    setPrice,
    setState,
    state,
    resetLegs
  );

  return (
    <div class="leg-styles">
      <p class="poppins-20-700 leg-styles__title">Ploča</p>
      <Materials
        setOverrideStep={setOverrideStep}
        isActive={activeStep == 0}
        onComplete={handleNextStep}
        items={boardMaterials}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
        basePrice={basePrice}
        setPrice={setPrice}
        dims={dims}
        boardManager={manager}
      />
      <Parametters
        isActive={activeStep == 1}
        onComplete={handleNextStep}
        items={boardParametters}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
        dims={dims}
        setPrice={setPrice}
        basePrice={basePrice}
        manager={manager}
        setOverrideStep={setOverrideStep}
      />
    </div>
  );
};
